import { MigrationMessagingBanner } from 'svh-conversations-settings-lib/migration';
import { getMigrationStatusUrl } from '../../../urls/getHelpDeskMigrationUrl';
import { useChannelInstanceByChannelId } from 'svh-onboarding-config-shared-lib/migration/hooks/useChannelInstance';
import { jsx as _jsx } from "react/jsx-runtime";
const CallingMigrationBanner = ({
  channel,
  inboxId
}) => {
  const {
    channelInstanceId
  } = channel;
  const {
    channelInstance
  } = useChannelInstanceByChannelId(channelInstanceId);
  if (!channelInstance) {
    return null;
  }
  return /*#__PURE__*/_jsx(MigrationMessagingBanner, {
    channel: channel,
    viewStatusRoute: getMigrationStatusUrl(inboxId, 'calling', channelInstance.id)
  });
};
CallingMigrationBanner.displayName = 'CallingMigrationBanner';
export default CallingMigrationBanner;